import React from 'react'
import Billboard from "../../components/Billboard";
import Links from "./Links/Links";
import MarkdownContent from "./MarkdownContent";
import squares from "../../images/background/articles-squares.svg";

const Quote = ({image, text, name, role}) => {
    return (
        <section className="CaseStudy-Quote">
            {image && <img src={image} alt={name} />}
            <blockquote>{text}</blockquote>
            <div className="CaseStudy-Quote__name">{name}</div>
            <div className="CaseStudy-Quote__role">{role}</div>
        </section>
    )
}


const Industry = ({name, icon}) => {
    if(!name) return null
    return (
        <div className="col-6">
            <div className="CaseStudy__indloc-flex">
                {icon}
                <div>
                    <div className="CaseStudy__subtitle">Industry</div>
                    <div>{name}</div>
                </div>
            </div>
        </div>
    )
}
const Location = ({name}) => {
    if(!name) return null
    return (
        <div className="col-6">
            <div className="CaseStudy__indloc-flex">
                <img src="/images/case-studies/icons/location-default.png" />
                <div>
                    <div className="CaseStudy__subtitle">Location</div>
                    <div>{name}</div>
                </div>
            </div>
        </div>
    )
}
const Challenges = ({challenges}) => {
    if(!challenges) return null

    const challengeList = challenges.map((challenge, idx) => {
        return (
            <div className="CaseStudy__challenge" key={idx}>
                <h3>{challenge.title}</h3>
                <div className="CaseStudy--challengeDescription">
                    <MarkdownContent content={challenge.text} className='' />
                </div>
            </div>
        )
    })

    return  <div className="row">
                <div className="col-md-12">
                    <h2>The Challenges</h2>
                    {challengeList}
                </div>
            </div>

}


const TemplateDefault = ({frontmatter, html, fields}) => {

    const showQuote = frontmatter.quote.text !== ''
    const quoteImageUrl = fields.quoteImage ? fields.quoteImage.publicURL : undefined
    const companyLogoUrl = fields.companyLogo ? fields.companyLogo.publicURL : undefined
    const industryIcon = frontmatter.company.industryIcon ? <img src={frontmatter.company.industryIcon} /> : <img src="/images/case-studies/icons/healthcare.png" />

    const results = frontmatter.results.map((result, idx) => {
        return <div className="CaseStudy--blueColumn__result" key={idx}>
            <div className="CaseStudy--blueColumn__subtitle">
                {result.kpi || result.title}
            </div>
            <div className="CaseStudy--blueColumn__text">
                {result.text}
            </div>
        </div>
    })

    const solutions = frontmatter.solutions ? frontmatter.solutions.map((solution, idx) => {
        return (
            <li key={idx}>{solution}</li>
        )
    }) : ''

    const videos = frontmatter.video?.length ? frontmatter.video.map((item, idx) => {
        return (
            <>
                <div className="row" style={{paddingTop: "2rem"}}>
                    <div className="col-md-12">
                        <video width="100%" controls="controls">
                            <source src={item.url} type="video/mp4" />
                        </video>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12" style={{padding: "10px 0 30px 0"}}>
                        <div className="col-md-12 CaseStudy-Quote__name" style={{textAlign: "right"}}>{item.author}</div>
                        <div className="col-md-12 CaseStudy-Quote__role" style={{textAlign: "right"}}>{item.role}</div>
                    </div>
                </div>
            </>
        )
    }) : ''


    return (
        <>
            <Billboard className="Billboard--resources" color="white">
                <div className="Billboard__top">
                    <h1 className="Billboard__title">{frontmatter.title}</h1>
                    <div className="Billboard__lead">CASE STUDY</div>
                    <div className="Billboard__cta"/>
                </div>
            </Billboard>

            <div className="CaseStudy">

                <section className="section blogWrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-9">
                                {showQuote && <Quote {...frontmatter.quote} image={quoteImageUrl}/>}
                                <div className="row CaseStudy--twoColumns">
                                    <div className="col-md-5">
                                        <img src={companyLogoUrl} alt={frontmatter.company.name}
                                             className="img-thumbnail"/>
                                        <div className="CaseStudy--blueColumn">
                                            <div className="CaseStudy--blueColumn__title">
                                                Results
                                            </div>
                                            <div className="CaseStudy--blueColumn__results">
                                                {results}
                                            </div>
                                            <div className="CaseStudy--blueColumn__solutionContainer">
                                                <div className="CaseStudy--blueColumn__title">
                                                    Cloudnexa Helped:
                                                </div>
                                                <div className="CaseStudy--blueColumn__results">
                                                    <ul className="CaseStudy--blueColumn__solutionlist">
                                                        {solutions}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 CaseStudy--rightColumnContainer">
                                        <h2>
                                            The Client
                                        </h2>
                                        <h3>
                                            {frontmatter.company.name}
                                        </h3>
                                        <div className="row">
                                            <Industry name={frontmatter.company.industry} icon={industryIcon} />
                                            <Location name={frontmatter.company.location}/>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 CaseStudy--companyDescription">
                                                <MarkdownContent content={frontmatter.company.description} />
                                            </div>
                                        </div>
                                        <Challenges challenges={frontmatter.challenges}/>
                                    </div>
                                </div>
                                <article className="article">
                                    <div
                                        className="CaseStudy--html"
                                        dangerouslySetInnerHTML={{__html: html}}
                                    />
                                </article>
                                { videos }
                            </div>

                            <div className="col-md-3">
                                <div className="blogSidebar">
                                    <Links/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>


        </>
    )

}

export default TemplateDefault